<template>
    <div class="wrapper">
        <!-- 顶部装饰背景区 -->
        <div class="header-bg">
            <div class="header-title">异常反馈查询</div>
        </div>

        <!-- 核心输入卡片 -->
        <div class="card-container input-card">
            <div class="div_name">
                <i class="icon-car"></i> 请输入车牌号进行查询
            </div>

            <plate-input ref="plateInput1"></plate-input>

            <div class="div_button" :class="{ 'is-loading': isLoading }" @click="handleConfirm">
                {{ isLoading ? '查询中...' : '确认查询' }}
            </div>
        </div>

        <!-- 底部温馨提示区 (提取自你原有CSS但未在HTML中使用的部分) -->
        <div class="card-container div_explain">
            <div class="explain_name">温馨提示</div>
            <div class="div_text">
                <p>1. 请确保输入的车牌号真实有效；</p>

            </div>
        </div>
    </div>
</template>

<script>
// import { getRecordByPlateNo, getParkinglotInfo, order } from "../api/coupon/platePay";
import { validatePlate } from '@/utils/plateValidator';
import plateInput from '../components/plateInput.vue';
// import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'PlatePay',
    components: {
        plateInput
    },
    data() {
        return {
            isLoading: false, // 新增：控制按钮 loading 状态防抖
            parkinglotId: undefined,
            totalPrice: undefined,
            plateNumber: undefined,
            parkRec: undefined,
            parkRecInfo: {},
            comeFrom: ''
        };
    },

    mounted() {
        console.log("this.$route.query", this.$route.query);

        const query = this.$route.query || {};

    },
    methods: {


                handleConfirm() {
            // 防抖：正在查询时忽略重复点击
            if (this.isLoading) return;

            // 从车牌输入组件中取出当前输入的车牌号
            const plateNumber = this.$refs.plateInput1
                ? this.$refs.plateInput1.getPlateNumber()
                : '';

            // 校验车牌号真实性（普通蓝牌 / 新能源车牌）
            if (!plateNumber) {
                this.$weui.alert('请输入车牌号');
                return;
            }

            if (!validatePlate(plateNumber).valid) {
                this.$weui.alert('请输入正确的车牌号');
                return;
            }

            // 保存车牌号，并携带正确的车牌号进行跳转
            this.plateNumber = plateNumber;

            this.$router.push({ name: "AlipayOrderFeedback", query: { plateNumber: this.plateNumber } });
        },

    }
};
</script>

<style lang="stylus" scoped>
    @import '~common/stylus/variable';
    @import '~common/stylus/mixin';

    .wrapper {
        position: relative;
        width: 100%;
        min-height: 100vh;
        background: #f4f6f8; /* 让背景色稍微柔和一些 */
        display: flex;
        flex-direction: column;
        align-items: center;

        /* 顶部装饰条，打破死板的布局 */
        .header-bg {
            width: 100%;
            height: 150px;
            background: linear-gradient(135deg, #06ae56 0%, #059b4c 100%);
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
            display: flex;
            justify-content: center;
            padding-top: 30px;
            
            .header-title {
                color: #ffffff;
                font-size: 20px;
                font-weight: bold;
                letter-spacing: 2px;
            }
        }

        /* 统一卡片样式 */
        .card-container {
            width: 90%;
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* 添加柔和的阴影 */
            box-sizing: border-box;
   
        }

        /* 输入区卡片 */
        .input-card {
            position: relative; /* 必须有 position，z-index 才会生效 */
    z-index: 999;       /* 设置极高层级，确保内部弹出的键盘能盖住全场 */
    margin-top: -60px;
    padding: 24px 20px;

            .div_name {
                font-size: 16px;
                font-weight: bold;
                color: #333;
                margin-bottom: 25px;
                display: flex;
                align-items: center;
                
                .icon-car {
                    margin-right: 8px;
                    font-style: normal;
                }
            }

            .div_button {
                color: #ffffff;
                width: 100%;
                height: 48px;
                background: #06ae56;
                /* 修复原代码中绿底蓝阴影的视觉违和，改为绿色阴影 */
                box-shadow: 0px 6px 12px 0px rgba(6, 174, 86, 0.3); 
                border-radius: 8px; /* 增大一点圆角 */
                font-size: 17px;
                font-weight: 500;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                letter-spacing: 2px;
                margin-top: 24px;
                transition: all 0.2s ease-in-out;

                &:active {
                    transform: scale(0.98); /* 点击反馈特效 */
                    background: #059b4c;
                }

                &.is-loading {
                    background: #83d6ab; /* loading 状态下变浅色 */
                    box-shadow: none;
                    pointer-events: none; /* 禁止点击 */
                }
            }
        }

        /* 提示信息卡片 */
        .div_explain {
            position: relative;
            z-index: 1;         /* 层级放低 */
            margin-top: 20px;
            padding: 20px;

            .explain_name {
                font-size: 15px;
                margin-bottom: 15px;
                color: #333;
                font-weight: bold;
                border-left: 3px solid #06ae56;
                padding-left: 8px;
                line-height: 1;
            }

            .div_text p {
                margin: 0 0 8px 0;
                font-size: 13px;
                line-height: 1.5;
                color: #666;
            }
        }
    }
</style>